
























































































































import {
  defineComponent,
  ref,
  watchEffect,
  reactive,
  onMounted,
  toRefs
} from '@vue/composition-api'
import { Message } from 'element-ui'
import VerifyCode from '@/components/verify-code/index.vue'
import {
  rememberMe,
  requestLogin,
  requestLoginByPhone
} from '@/service/userService'
import UpdatePasswordDialog from '../user/account-safety/components/update-password.vue'
import CopyRight from '@/components/copyright/footer.vue'
import { AUTH_TPYE } from './constant'
import useLogin from './useLogin'
import { UserModule } from '@/store/modules/user'
import Cookies from 'js-cookie'

const replaceChar = unescape('%u25CF')

export default defineComponent({
  name: 'Login',
  components: {
    VerifyCode,
    UpdatePasswordDialog,
    CopyRight
  },
  setup(props, { root }) {
    const { checkPhone } = useLogin()
    const staticPath = `/hxx-session/login?redirectUri=${location.origin}/admin/`
    const platId = Cookies.get('platId') || ''
    const loginPath = `${location.protocol}//${location.host}${staticPath}&platId=${platId}`
    const state: Record<string, any> = reactive({
      loginType: 'phone', //账号密码登录:account，手机号验证码登录:phone
      placeholder: {
        account: '账号/手机号登录',
        phone: '请输入手机号'
      },
      smsCode: '',
      verifyCodeVisible: false, //获取图片验证码的弹框
      imgCaptchaObj: {}, //图形验证码相关信息
      showPasswordDialog: false,
      smsCodeCountdown: 0, //获取验证码的倒计时
      loginPath
    })

    // 内部跳转逻辑 - 根据接口返回默认打开位置处理
    const gotoPage = async () => {
      const nextPath = '/myapp'
      root.$router.replace({ path: nextPath })
    }
    // 登录成功处理--提示信息
    const loginSuccessHandler = async () => {
      // 成功提示-之后进入系统首页
      Message({
        type: 'success',
        message: '登录成功',
        duration: 1000,
        onClose: () => {
          // 跳转首页
          gotoPage()
        }
      })
    }

    // 用户名
    const username = ref('')
    // 密码
    const password = reactive({
      show: '',
      real: '',
      mask: ''
    })

    // 用户协议
    const agreement = ref(false)
    // 记住密码
    const remenberme = ref(false)
    // 是否禁用
    const isDisabled = ref(true)

    // 获取当前本地记住的密码
    const { name = '', pwd = '' } = rememberMe.get()
    remenberme.value = !!name && !!pwd
    username.value = name
    const remenberMask = pwd.replace(/./g, replaceChar)
    password.show = remenberMask
    password.real = pwd
    password.mask = remenberMask

    // 是否显示明文
    const showPwd = ref(false)
    // 输入的错误信息
    const inputError = reactive({
      nameError: '',
      pwdError: '',
      phoneError: ''
    })
    // 清空错误提示
    const clearError = () => {
      inputError.nameError = ''
      inputError.pwdError = ''
      inputError.phoneError = ''
    }
    // 点击切换tabs
    const handleClick = () => {
      clearError()
      username.value = ''
      password.real = ''
      state.smsCode = ''
      showPwd.value = false
    }

    // 点击获取验证码
    const getVerifyCode = async () => {
      inputError.phoneError = '' // 先清空错误提示
      // 先验证手机号的格式
      const phone = username.value
      const msg = checkPhone(phone)
      if (msg) {
        inputError.phoneError = msg
      } else {
        state.verifyCodeVisible = true
      }
    }
    // 获取短信验证码之后，显示倒计时
    const verifyCodeSuccess = (flag: any) => {
      if (flag) {
        state.smsCodeCountdown = 60
        let timer = setInterval(() => {
          if (state.smsCodeCountdown <= 0) {
            clearInterval(timer)
          }
          state.smsCodeCountdown--
        }, 1000)
      }
      state.verifyCodeVisible = false
    }

    // 登录按钮点击
    const loginClick = async () => {
      try {
        if (isDisabled.value) {
          return false
        }
        isDisabled.value = true
        let errNo = 0
        let msg = ''
        //账号登录
        if (state.loginType == 'account') {
          const data: any = await requestLogin(username.value, password.real)
          errNo = data.errNo
          msg = data.msg
          // 记住账号
          if (remenberme.value) {
            rememberMe.set(username.value, password.real)
          } else {
            rememberMe.clear()
          }
        } else {
          // 提交前验证
          inputError.phoneError = ''
          const errorMsg = checkPhone(username.value)
          if (errorMsg) {
            // 恢复可点击
            isDisabled.value = false
            inputError.phoneError = errorMsg
            return false
          }
          //手机号验证码登录
          const data = await requestLoginByPhone({
            phone: username.value,
            smsCode: state.smsCode
          })
          errNo = data.errNo
          msg = data.msg
        }
        // 恢复可点击
        isDisabled.value = false
        // 不成功则提示相关信息
        if (errNo !== 0) {
          Message.warning(msg)
          return
        }
        loginSuccessHandler()
      } catch (error) {
        isDisabled.value = false
      }
    }

    // 账号密码都不为空，按钮可点
    watchEffect(() => {
      if (state.loginType == 'account') {
        isDisabled.value =
          username.value.length < 1 ||
          password.real.length < 6 ||
          !agreement.value
        return
      }
      isDisabled.value =
        username.value.length !== 11 ||
        state.smsCode.length < 1 ||
        !agreement.value
    })

    const forgotPassword = () => {
      state.showPasswordDialog = true
    }

    onMounted(() => {
      if (UserModule.hasLogin) {
        root.$router.replace({ path: '/home' })
        return
      }
    })

    return {
      ...toRefs(state),
      ...toRefs(inputError),
      username,
      password,
      agreement,
      remenberme,
      isDisabled,
      showPwd,
      loginClick,
      handleClick,
      getVerifyCode,
      forgotPassword,
      AUTH_TPYE,
      verifyCodeSuccess
    }
  }
})
